import { cloneDeep } from 'lodash'
import log from '@/logger'
import { errorResponseHandler } from '@/errors'
import store from '@/store'

const interceptorResponseSuccess = response => {
  const { status, config, data } = response
  log.info('API Response', config.method, config.url, status, cloneDeep(data))
  return data
}

const interceptorResponseError = error => {
  if (error.response) {
    log.error('API Response', error.response.status, error.response.config.url)
  } else if (error.request) {
    log.error('The request was made but no response was received', error.request)
  } else {
    log.error('Something happened in setting up the request that triggered an error', error.message)
  }

  const err = errorResponseHandler(error)

  if (err.isNetworkError()) {
    store.commit('errors/setConnectionError', true)
  }

  if (err.isUnauthorized()) {
    store.dispatch('auth/logout')
  }

  return Promise.reject(err)
}

export { interceptorResponseSuccess, interceptorResponseError }
